// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3XGOA","vLegacy":"SelectSecondary_vLegacy__Dw5_C","error":"SelectSecondary_error__2r0BV","disabled":"SelectSecondary_disabled__2ktiH"};